import { USER_LIST_WITH_TYPE } from '../constants'
import { appLoading, appMessage } from './appActions'
import axios from 'axios'


import { DB, auth } from '../firebase'

export const getUserListWithType = type => dispatch => new Promise(resolve => {
  DB.collection('users')
  .where("type", "==", type)
  .onSnapshot( response => {
    response = response.docs.map( r => ({ id: r.ref.id, ...r.data() }) )
    dispatch({ type: USER_LIST_WITH_TYPE , payload: {[type]: response} })
    resolve(true);
  })
})

export const updateUserData = userData => async(dispatch) => {
  dispatch(appLoading(true))
  await DB.collection('users').doc(userData.id).set(userData)
  dispatch(appLoading(false))
  dispatch({ type: 'changedDataHandledByListenerAlready' })
}

export const addNewUser = userData => async(dispatch) => {
  dispatch(appLoading(true))
  await auth.createUserAndRetrieveDataWithEmailAndPassword(userData.email, userData.pass)
    .then(async newUserData => {
      delete userData.pass;
      delete userData.pass2;
      await DB.collection('users').doc(newUserData.user.uid).set(userData)
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}

export const updateUserEmailPassword = (email, password, userId, adminId) => dispatch => {
  dispatch(appLoading(true))
  axios.get(`https://us-central1-fishmarket-39331.cloudfunctions.net/changeUser?token=${userId}&email=${email}&pass=${password}&auth=${adminId}`)
    .then( async r => {
      await DB.collection('users').doc(userId).update({email: email})
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}

export const deleteUser = (userId, adminId) => dispatch => {
  dispatch(appLoading(true))
  axios.get(`https://us-central1-fishmarket-39331.cloudfunctions.net/delUser?token=${userId}&auth=${adminId}`)
    .then( async r => {
      await DB.collection('users').doc(userId).delete()
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js